import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../../../../environments/environment';
import { HttpService } from '../../../../shared/services/http/http-client.service';

const API = environment.url_server;

@Injectable({
  providedIn: 'root',
})
export class ListaUserTerceiroService {

  constructor(private http: HttpService) { }

  buscaUsuario(data: any, successHandle: Function, errorHandle: Function) {
    return this.http.doGet('/employeeAdmin', data, successHandle, errorHandle);
  }

}
